import React from 'react';
import {useNavigate} from "react-router-dom";
import {OrderType} from "../../../../services/Api/types";
import OrderTypeIcon from "../../../../components/Common/OrderTypeIcon";
import {useTranslation} from "react-i18next";
import {ReactComponent as ArrowRightIco} from "../../../../../images/icons/arrow-right.svg";

interface Props {
    link: string;
    orderType: OrderType;
}

const MultistoreOrderTypesModalElement = ({link, orderType}: Props) => {
    const navigate = useNavigate();
    const {t} = useTranslation();

    const handleClick = () => {
        navigate(`${link}/${orderType}`);
    }

    return (
        <button onClick={handleClick} className="btn btn-lg btn-default btn-nav w-100">
            <OrderTypeIcon orderType={orderType}/>
            <h1 className="h6 mb-0">
                {t(`enums.order.type.${orderType}`)}
            </h1>
            <ArrowRightIco/>
        </button>
    )
}

export default MultistoreOrderTypesModalElement;